export function simpleKtName(qualifiedName: string): string {
  return qualifiedName.substring(qualifiedName.lastIndexOf(".") + 1);
}
